export default __webpack_public_path__ + "static/media/chat.696b14a7.png";